const inIframe = () => window.self !== window.top;

export default inIframe;
